// extracted by mini-css-extract-plugin
export default {"root":"BorrowerProjectFeedback_root__a94Ar","item":"BorrowerProjectFeedback_item__LYFJm"};